import React, { useState, useEffect } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import { MdMarkEmailRead } from "react-icons/md";
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import { IoMdAdd } from "react-icons/io";
import Hexapi from "../usefulcomps/HexAPI/Hexapi";
import { TimeFormatterV2 } from "../usefulcomps/Timeformatter/TimeFormatter";
import axios from "axios";
function QuotationForm(props) {
  const [showmodal, setshowmodal] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);
  const [uspofjakson, setuspofjakson] = useState(false);
  const [CompanyPortfolio, setCompanyPortfolio] = useState(false);
  const [Quotation, setQuotation] = useState(0);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [TransportationCost, setTransportationCost] = useState(0);
  const [ServiceCharge, setServiceCharge] = useState(0);
  const [RevisionNo, setRevisionNo] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [
    OpportunityReferenceNumberDisable,
    setOpportunityReferenceNumberDisable,
  ] = useState(false);
  const [OpportunityReferenceNumber, setOpportunityReferenceNumber] =
    useState("");
  const [ValidityDate, setValidityDate] = useState(new Date());
  useEffect(() => {
    console.log(props.disabled);
  }, []);

  const getdata = async () => {
    setModalLoading(true);
    let obj = {
      query: `[dbo].[CRM_Proc_Quotation_GetData] @agentID='{0}', @EnquiryID='{1}'`,
      queryArr: [`${props.AgentID}`, `${props.enquiryID}`],
    };
    try {
      const resp = await Hexapi(obj);
      console.log(resp);
      setTotalAmount(resp[""][0]["totalamount"]);
      setDiscount(resp[""][0]["discount"]);
      setRevisionNo("0" + resp[""][0]["revision"]);
      setTransportationCost(resp[""][0]["transportationcost"]);
      setServiceCharge(resp[""][0]["servicecharge"] ?? 0);
      const validityObj = resp[""][0]?.validity;
      const formattedDate = validityObj?.date
        ? validityObj.date.split(" ")[0]
        : "";
      setValidityDate(formattedDate);
      setOpportunityReferenceNumber(resp[""][0]["opportunityreferencenumber"]);
      setOpportunityReferenceNumberDisable(
        resp[""][0]["opportunityreferencenumberdisable"],
      );
      if (resp[""][0]["quotation"] != undefined) {
        setQuotation(resp[""][0]["quotation"]);
      } else {
        setQuotation(resp[""][0]["totalamount"]);
      }
      setModalLoading(false);
    } catch (err) {
      console.error("Error fetching row details:", err);
    } finally {
      setModalLoading(false);
    }
  };
  const submit = async () => {
    console.log(OpportunityReferenceNumber);
    if (
      OpportunityReferenceNumber === "" ||
      OpportunityReferenceNumber === null ||
      OpportunityReferenceNumber === undefined
    ) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter Opportunity Reference Number.",
      });
      return;
    }
    if (
      TransportationCost === "" ||
      TransportationCost === null ||
      TransportationCost === undefined
    ) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter Transportation Cost.",
      });
      return;
    }
    if (
      ServiceCharge === "" ||
      ServiceCharge === null ||
      ServiceCharge === undefined
    ) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter Service Charge.",
      });
      return;
    }
    if (Discount === "" || Discount === null || Discount === undefined) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter Discount.",
      });
      return;
    }
    if (Quotation === "" || Quotation === null || Quotation === undefined) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please enter Quotation amount.",
      });
      return;
    }
    if (!ValidityDate) {
      Swal.fire({
        icon: "warning",
        title: "Required",
        text: "Please select a Validity date.",
      });
      return;
    }
    setModalLoading(true);

    let obj = {
      query: `[dbo].[CRM_Proc_Quotation_Submit] 
        @agentID='{0}', 
        @EnquiryID='{1}', 
        @TransportationCost='{2}', 
        @Discount='{3}', 
        @OpportunityReferenceNumber='{4}', 
        @Validity='{5}', 
        @Quotation='{6}',
        @ServiceCharge='{7}'`,
      queryArr: [
        `${props.AgentID}`,
        `${props.enquiryID}`,
        `${TransportationCost}`,
        `${Discount}`,
        `${OpportunityReferenceNumber}`,
        `${TimeFormatterV2(ValidityDate, "fulldate", "YYYY-MM-DD HH:mm:ss")}`,
        `${Quotation}`,
        `${ServiceCharge}`,
      ],
    };

    try {
      const resp = await Hexapi(obj);

      if (resp?.[""]?.[0]?.command === 1) {
        const postData = {
          TransportationCost,
          ServiceCharge,
          Discount,
          EnquiryID: props.enquiryID,
          Today: new Date().toLocaleDateString("en-GB"),
          OpportunityReferenceNumber,
          UspOfJakson: uspofjakson,
          CompanyPortfolio,
          Validity: formatDate(ValidityDate),
          CompanyName: resp[""][0]["companyname"],
          OfficeAddress: resp[""][0]["officeaddress"],
          SiteAddress: resp[""][0]["siteaddress"],
          City: resp[""][0]["city"],
          GstNumber: resp[""][0]["gstnumber"],
          EmailID: resp[""][0]["emailid"],
          CustomerName: resp[""][0]["customername"],
          Rating: resp[""][0]["rating"],
          OtherSpecifications: resp[""][0]["otherspecifications"],
          Pincode: resp[""][0]["pincode"],
          Panel: resp[""][0]["panel"],
          State: resp[""][0]["state"],
          Qty: resp[""][0]["qty"],
          EngineModel: resp[""][0]["enginemodel"],
          Quotation,
          QuotationID: resp[""][0]["quotationid"],
          ContactNumber: resp[""][0]["contactnumber"],
          Revision: RevisionNo,
        };

        const res = await fetch(`${process.env.PUBLIC_URL}/Apiinfo.json`);
        const data = await res.json();
        if (!data?.apipath) throw new Error("API Path missing");

        const url = `${data.apipath}SendQuotation.php`;

        const response = await axios.post(url, postData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // ✅ SUCCESS SWAL
        await Swal.fire({
          icon: "success",
          title: "Quotation Sent",
          text: "Quotation email has been sent successfully.",
          confirmButtonText: "OK",
        });

        setshowmodal(false);
        props.RefreshLogs();
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Failed",
        text:
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong while sending quotation",
      });
    } finally {
      setModalLoading(false);
    }
  };
  const handleQuotationChange = (value) => {
    if (!isNaN(value) && TotalAmount) {
      const discount = ((TotalAmount - value) / TotalAmount) * 100;
      setDiscount(discount > 0 ? discount : 0);
    } else {
      setDiscount("");
    }
  };
  const handleDiscountChange = (value) => {
    console.log(value, TotalAmount);
    if (!isNaN(value) && TotalAmount) {
      var quotationAmount = TotalAmount - (value * TotalAmount) / 100;
      console.log(quotationAmount);
      quotationAmount = Number(quotationAmount.toFixed(2));
      setQuotation(quotationAmount > 0 ? quotationAmount : 0);
    } else {
      setQuotation("");
    }
  };
  const formatDate = (dateInput) => {
    if (!dateInput) return "";

    // Handle SQL date wrapper objects like { date: '2026-06-08 00:00:00.000' }
    if (typeof dateInput === "object" && dateInput !== null && dateInput.date) {
      dateInput = dateInput.date;
    }

    let d = null;

    if (dateInput instanceof Date) {
      d = dateInput;
    } else {
      let s = String(dateInput).trim();

      if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}/.test(s)) {
        s = s.replace(" ", "T");
      }

      d = new Date(s);

      if (isNaN(d.getTime())) {
        const datePart = s.split("T")[0].split(" ")[0];
        const parts = datePart.split("-");
        if (parts.length === 3) {
          const y = Number(parts[0]);
          const m = Number(parts[1]);
          const day = Number(parts[2]);
          if (!Number.isNaN(y) && !Number.isNaN(m) && !Number.isNaN(day)) {
            d = new Date(y, m - 1, day);
          }
        }
      }

      if (!d || isNaN(d.getTime())) return "";
    }

    return (
      String(d.getDate()).padStart(2, "0") +
      "/" +
      String(d.getMonth() + 1).padStart(2, "0") +
      "/" +
      d.getFullYear()
    );
  };

  const formatted = formatDate("2026-02-10");
  console.log(formatted);
  return (
    <>
      <button
        disabled={props.disabled}
        onClick={() => {
          setshowmodal(true);
          getdata();
        }}
        style={{
          background: "none",
          border: "none",
          padding: 0,
          cursor: props.disabled ? "not-allowed" : "pointer",
        }}
      >
        <IoMdAdd
          style={{ color: "grey", fontSize: "25px" }}
          title="Send Quote"
        />
      </button>
      <Modal
        show={showmodal}
        onHide={() => setshowmodal(false)}
        dialogClassName="custom-modall-quote"
        size="lg"
        scrollable
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton style={{ backgroundColor: "#f5f9ff" }}>
          <div className="w-100">
            <div>
              <strong>Quotation Form</strong>
            </div>

            <div className="d-flex gap-4 mt-2">
              <span>
                <strong>EnquiryID:</strong> {props.enquiryID}
              </span>
              <span>
                <strong>CustomerName:</strong> {props.customerName}
              </span>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {!modalLoading ? (
            <>
              <form className="p-3 mx-auto" style={{ maxWidth: "720px" }}>
                <div className="row g-3">
                  <div className="col-10">
                    <label className="form-label">Opportunity Ref. No.</label>
                    <span className="text-danger">*</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter reference number"
                      value={OpportunityReferenceNumber}
                      onChange={(e) =>
                        setOpportunityReferenceNumber(e.target.value)
                      }
                      disabled={OpportunityReferenceNumberDisable}
                      required
                    />
                  </div>
                  <div className="col-2">
                    <label className="form-label">Revision</label>
                    <input
                      type="text"
                      className="form-control"
                      value={RevisionNo}
                      disabled
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Transportation Cost</label>
                    <span className="text-danger">*</span>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="₹"
                      value={TransportationCost}
                      onChange={(e) => setTransportationCost(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Service Charge</label>
                    <span className="text-danger">*</span>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="₹"
                      value={ServiceCharge}
                      onChange={(e) => setServiceCharge(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Discount</label>
                    <span className="text-danger">*</span>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="% or ₹"
                      value={Discount}
                      min={0}
                      onChange={(e) => {
                        handleDiscountChange(e.target.value);
                        setDiscount(e.target.value);
                      }}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Quotation</label>
                    <span className="text-danger">*</span>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Quotation"
                      value={Quotation}
                      max={TotalAmount}
                      min={0}
                      onChange={(e) => {
                        let value = Number(e.target.value);
                        if (value > TotalAmount) {
                          value = TotalAmount;
                        }
                        if (value < 0) {
                          value = 0;
                        }
                        value = Number(value.toFixed(2));
                        setQuotation(value);
                        handleQuotationChange(value);
                      }}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Validity</label>
                    <span className="text-danger">*</span>
                    <input
                      type="date"
                      className="form-control"
                      value={ValidityDate}
                      onChange={(e) => setValidityDate(e.target.value)}
                      required
                    />
                  </div>

                  {/* Checkboxes */}
                  <div className="col-12">
                    <div className="d-flex flex-wrap gap-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="uspJakson"
                          checked={uspofjakson}
                          onChange={(e) => setuspofjakson(e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="uspJakson">
                          USP of Jakson
                        </label>
                      </div>

                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="companyPortfolio"
                          checked={CompanyPortfolio}
                          onChange={(e) =>
                            setCompanyPortfolio(e.target.checked)
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="companyPortfolio"
                        >
                          Company Portfolio
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 text-center">
                    <IconButton
                      sx={{
                        mt: 3,
                        px: 4,
                        py: 1.2,
                        borderRadius: "8px",
                        backgroundColor: "#000",
                        border: "1px solid #000",
                        color: "#fff",
                        "&:hover": {
                          backgroundColor: "#fff",
                          color: "#000",
                        },
                        fontSize: "16px",
                        fontWeight: 600,
                      }}
                      onClick={() => submit()}
                    >
                      Submit
                    </IconButton>
                  </div>
                </div>
              </form>
            </>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default QuotationForm;
